import _ from 'lodash';
// import axios from 'axios';
import moment from 'moment';
import { connect } from 'react-redux';
import React, { useState, useEffect, useRef } from 'react';
import { constant } from '../../../Utils/constants';
// import localStorage from '../../../../../utils/localStorage';
import InputComponent from '../../../Widgets/InputComponent';
import translation from '../../../../../commons/translation';
// import { API_HIERARCHYMODULE } from '../../../../../commons/api';

import { UserOutlined, CalendarOutlined } from '@ant-design/icons';
import {
  Form,
  message,
  Select,
  DatePicker,
  Card,
  Drawer,
  Divider,
  Space,
  Empty,
  Pagination,
  Button
} from 'antd';
import {
  // getDeviceList,
  // getOrganisationsList,
  // getSitesList,
  getTaskList,
  getTaskById,
  filterTaskByReference,
  // getHierarchyList,
  _getUOMList,
  // getUsersList
} from '../../../Utils/FormCalls';
import Title from 'antd/es/typography/Title';

const { Option } = Select;

const WorkOrderJobPlanesTask = (props) => {
  // const [deviceList, setDeviceList] = useState([]);
  // const [organisationsList, setOrganisationsList] = useState([]);
  // const [sitesList, setSitesList] = useState([]);
  const [recordData, setRecordData] = useState(props.formObject?.TaskData || []);
  const [formObject, setFormObject] = useState(props.formObject || {});
  // const [selectedHour, setSelectedHour] = useState(moment().hour());
  // const [disabledMinutes, setDisabledMinutes] = useState([]);
  // const [disabledEndHours, setDisabledEndHours] = useState([]);
  const [workOrderStatus, setWorkOrderStatus] = useState(props.workOrderStatus);
  const [fileData, setFileData] = useState(props.fileData || []);
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  // const [hierarchyList, setHierarchyList] = useState([]);
  const [UOMList, setUOMList] = useState([]);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [TaskList, setTaskList] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [open, setOpen] = useState(false);

  const workOrderJobPlanRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // const hierarchyList = await getHierarchyList();
        // setHierarchyList(hierarchyList);

        // const deviceList = await getDeviceList();
        // setDeviceList(deviceList.data);

        // const usersList = await getUsersList();
        // setUsersList(usersList);

        // const organisationsList = await getOrganisationsList();
        // setOrganisationsList(organisationsList.data);

        // const sitesList = await getSitesList();
        // setSitesList(sitesList.data);

        let TaskList = await getTaskList('Active');
        TaskList = filterTaskByReference(TaskList, recordData);
        setTaskList(TaskList);

        const UOMList = await _getUOMList();
        setUOMList(UOMList);
      } catch (error) {
        message.warning(`${error.message}`);
      }
    };

    fetchData();
  }, [recordData]);

  //   useEffect(() => {
  //     setDisabledMinutes(getDisabledMinutes(selectedHour));
  //     setDisabledEndHours(getDisabledEndHours());
  //   }, [selectedHour]
  // );

  const disabledMinutes = (hour) => {
    const minutes = [];
    if (hour === moment().hour()) {
      const currentMinute = moment().minute();
      for (let i = currentMinute; i < 60; i++) {
        minutes.push(i);
      }
    }
    return minutes;
  };

  const disabledEndHours = () => {
    const hours = [];
    for (let i = 0; i < moment().hour(); i++) {
      hours.push(i);
    }
    return hours;
  };

  // const handleHourChange = (event) => {
  //   setSelectedHour(parseInt(event.target.value, 10));
  // };


  useEffect(() => {
    if (props.formObject && Object.keys(props.formObject).length === 0 && Object.keys(formObject).length === 0) {
      onReset();
    }
    if (props.formObject && Object.keys(props.formObject).length === 0) {
      workOrderJobPlanRef.current?.setFieldsValue(props.formObject);
    }
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    if (props.formObject !== formObject) {
      workOrderJobPlanRef.current?.setFieldsValue(props.formObject);
      setFormObject(props.formObject);
      setRecordData(props.formObject?.TaskData || []);
      setWorkOrderStatus(props.workOrderStatus || null);
      setFileData(props.fileData || null);
    }
  }, [props]);

  const onPaginationChange = (current, pageSize) => {
    setCurrent(current);
    setPageSize(pageSize);
  };

  // const handleChange = (value, key) => {
  //   setFormObject((prev) => ({
  //     ...prev,
  //     [key]: value
  //   }));
  // };

  const onReset = () => {
    workOrderJobPlanRef.current.resetFields();
  };

  const TaskOnChange = async (value) => {
    try {
      // Fetch task data by ID
      let TaskData = await getTaskById(value, 'withoutId');

      // Get the current form object from state
      let updatedFormObject = { ...formObject };
      let data = updatedFormObject.TaskData || [];

      // Clone and modify TaskData
      const clonedTaskData = _.cloneDeep(TaskData);
      if (clonedTaskData && clonedTaskData.StartTime) {
        clonedTaskData.StartTime = moment.utc(clonedTaskData.StartTime, 'YYYY-MM-DD HH:mm:ss');
        clonedTaskData.EndTime = moment.utc(clonedTaskData.EndTime, 'YYYY-MM-DD HH:mm:ss');
      }

      // Push the modified TaskData into the existing TaskData array
      data.push(clonedTaskData);

      // Update the form object with the new TaskData
      updatedFormObject.TaskData = data;

      // Update state
      setFormObject(updatedFormObject);
      setSelectedTask(value); // Update selected task

      // Set the form values
      workOrderJobPlanRef.current.setFieldsValue(updatedFormObject);
    } catch (error) {
      message.error(`Error fetching task data: ${error.message}`);
    }
  };

  // const handleSelect = (value, mainIndex, subindex, keyName, selectedObject) => {
  //   const updatedTaskData = [...formObject.TaskData];
  //   updatedTaskData[mainIndex][keyName][subindex] = {
  //     ...selectedObject[0]
  //   };
  //   setFormObject((prev) => ({
  //     ...prev,
  //     TaskData: updatedTaskData
  //   }));
  //   workOrderJobPlanRef.current.setFieldsValue({ TaskData: updatedTaskData });
  // };

  const datepickerChange = (date, dateString, index, key) => {
    const formObject = workOrderJobPlanRef.current.getFieldsValue();
    let EstimatedDuration = null;

    if (key === 'EndTime' && formObject.TaskData && formObject.TaskData[index]?.StartTime) {
      const startTime = formObject.TaskData[index].StartTime;
      const endTime = date;

      const ms = moment(endTime, 'YYYY-MM-DD HH:mm').diff(moment(startTime, 'YYYY-MM-DD HH:mm'));
      const d = moment.duration(ms);
      EstimatedDuration = Math.floor(d.asHours()) + moment.utc(ms).format(':mm:ss');
    } else if (key === 'StartTime' && formObject.TaskData && formObject.TaskData[index]?.EndTime) {
      const endTime = formObject.TaskData[index].EndTime;
      const startTime = date;

      const ms = moment(endTime, 'YYYY-MM-DD HH:mm').diff(moment(startTime, 'YYYY-MM-DD HH:mm'));
      const d = moment.duration(ms);
      EstimatedDuration = Math.floor(d.asHours()) + moment.utc(ms).format(':mm:ss');
    }

    formObject.TaskData[index].EstimatedDuration = EstimatedDuration;
    workOrderJobPlanRef.current.setFieldsValue(formObject);
  };

  const getDisabledHours = (e, index, key) => {
    // getDisabledHours = (e, index, key) => {
    let hours = [];
    let minutes = [];
    let StartDateTime = '';
    let EndDateTime = '';
    let StartDate = '';
    let EndDate = '';

    if (key === 'StartTime') {
      StartDateTime = moment(e).format('YYYY-MM-DD HH:mm');
      EndDateTime = moment
        .utc(
          this.workOrderJobPlanRef.current.getFieldValue() &&
          this.workOrderJobPlanRef.current.getFieldValue().TaskData &&
          this.workOrderJobPlanRef.current.getFieldValue().TaskData[index] &&
          this.workOrderJobPlanRef.current.getFieldValue().TaskData[index]['EndTime'],
          'YYYY-MM-DD HH:mm'
        )
        .local();

      StartDate = moment(e).format('YYYY-MM-DD');
      EndDate = moment
        .utc(
          this.workOrderJobPlanRef.current.getFieldValue() &&
          this.workOrderJobPlanRef.current.getFieldValue().TaskData &&
          this.workOrderJobPlanRef.current.getFieldValue().TaskData[index] &&
          this.workOrderJobPlanRef.current.getFieldValue().TaskData[index]['EndTime']
        )
        .local()
        .format('YYYY-MM-DD');
    } else if (key === 'EndTime') {
      StartDateTime = moment
        .utc(
          this.workOrderJobPlanRef.current.getFieldValue() &&
          this.workOrderJobPlanRef.current.getFieldValue().TaskData &&
          this.workOrderJobPlanRef.current.getFieldValue().TaskData[index] &&
          this.workOrderJobPlanRef.current.getFieldValue().TaskData[index]['StartTime'],
          'YYYY-MM-DD HH:mm'
        )
        .local();
      EndDateTime = moment(e).format('YYYY-MM-DD HH:mm');

      StartDate = moment
        .utc(
          this.workOrderJobPlanRef.current.getFieldValue() &&
          this.workOrderJobPlanRef.current.getFieldValue().TaskData &&
          this.workOrderJobPlanRef.current.getFieldValue().TaskData[index] &&
          this.workOrderJobPlanRef.current.getFieldValue().TaskData[index]['StartTime']
        )
        .local()
        .format('YYYY-MM-DD');
      EndDate = moment(e).format('YYYY-MM-DD');
    }
    if (
      key === 'StartTime' &&
      moment(StartDate).isSame(
        moment(EndDate) || moment(StartDateTime).hours() === moment(EndDateTime).hours()
      )
    ) {
      for (var i = 0; i <= 24; i++) {
        if (i > moment(EndDateTime).hours()) {
          hours.push(i);
        }
      }
      if (moment(StartDate).isSame(moment(EndDate))) {
        for (var j = 0; j <= 60; j++) {
          if (j > moment(EndDateTime).minutes() - 1) {
            minutes.push(j);
          }
        }
      }
      return {
        disabledHours: () => hours,
        disabledMinutes: () => minutes
      };
    } else if (
      key === 'EndTime' &&
      moment(StartDate).isSame(
        moment(EndDate) || moment(StartDateTime).hours() === moment(EndDateTime).hours()
      )
    ) {
      for (var k = 0; k < moment(StartDateTime).hours(); k++) {
        if (k < 25) {
          hours.push(k);
        }
      }

      if (moment(StartDate).isSame(moment(EndDate))) {
        for (var K = 0; K < moment(StartDateTime).minutes() + 1; K++) {
          if (K < 61) {
            minutes.push(K);
          }
        }
      }
      return {
        disabledHours: () => hours,
        disabledMinutes: () => minutes
      };
    }
    // };
  };


  const onFinish = () => { };

  const disabledDate = (currentDay) => {
    return currentDay > moment().endOf('day');
  };

  const add = () => {
    setFormObject((prev) => ({
      ...prev,
      TaskData: [...(prev.TaskData || []), { TaskName: 'New Task' }]
    }));
  };
  const onClose = () => {
    setOpen(false);
  };
  const _editRecord = (id) => {
    // You can filter the formObject here if needed
    // const selectedTaskData = formObject?.TaskData?.filter(item => item.TaskName === id);

    setSelectedTask(id); // Set the selected task
    setOpen(true);       // Open the drawer or modal
  };
  const add3Dots = (text, limit) => {
    const dots = '...';
    if (text && text.length > limit) {
      return text.substring(0, limit) + dots;
    }
    return text;
  };

  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!'
    },
    number: {
      range: '${label} must be between ${min} and ${max}'
    },
    pattern: {
      mismatch: '${label} does not match pattern'
    }
  };
  const IconText = ({ icon, text }) => (
    <Space>
      {React.createElement(icon)}
      {text}
    </Space>
  );
  const listData = formObject && formObject.TaskData;

  return (
    <div>
      <Form
        ref={workOrderJobPlanRef}
        name={'jobplan'}
        initialValues={formObject}
        layout="horizontal"
        labelCol={{ flex: '130px' }}
        labelAlign="right"
        labelWrap
        validateMessages={validateMessages}
      >
        <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '10px' }}>
          <Form.Item name="JobPlanName"></Form.Item>
          <Form.Item name="JobPlanDescription"></Form.Item>
          <Form.Item
            style={{ width: '100%', flex: '50%' }}
            label={translation(translationCache, constant.addTask)}
            name="TaskName"
          >
            <Select
              placeholder={translation(translationCache, 'Select Task')}
              defaultValue={selectedTask}
              onChange={(value) => TaskOnChange(value)}
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <Divider style={{ margin: '8px 0' }} />
                  <Space style={{ padding: '0 8px 4px' }}>
                    <Button type='primary' onClick={add}>
                      {translation(translationCache, constant.addNewTask)}{' '}
                    </Button>
                  </Space>
                </>
              )}
              style={{ width: '30%' }}
            >
              {TaskList && Array.isArray(TaskList) && TaskList.map((task, index) => (
                <Option key={index} value={task.Id}>
                  {task.TaskName}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item style={{ width: '100%', flex: '50%' }}>
            <InputComponent style={{ display: 'none' }} />
          </Form.Item>
        </div>

        <div style={{ margin: '0px 40px' }}>
          <Form.Item name="TaskData">
            {listData && Array.isArray(listData) && listData.length !== 0 ? (
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {listData
                  .filter((_, index) => index >= pageSize * current - pageSize && index < pageSize * current)
                  .map((list, index) => (
                    <Card
                      key={list.TaskName}
                      onClick={() => _editRecord(index)}
                      style={{ width: '410px', padding: '5px', margin: '5px' }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Title >
                          {add3Dots(list['TaskName'])}
                        </Title>
                        <div style={{ margin: '0px 0px 7px 0px' }}>
                          <IconText icon={UserOutlined} text={list['CreatedBy']} />
                        </div>
                        <div style={{ margin: '0px 0px 7px  0px' }}>
                          <IconText icon={CalendarOutlined} text={moment(list['CreatedTime']).format('DD-MM-YYYY HH:mm:ss')} />
                        </div>
                      </div>
                    </Card>
                  ))}
              </div>
            ) : (
              <Empty style={{ color: 'white' }} image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}

            {listData && Array.isArray(listData) && listData.length !== 0 ? (
              <div style={{ display: 'flex', flexDirection: 'row', margin: '14px' }}>
                <Pagination
                  current={current}
                  onChange={onPaginationChange}
                  total={listData.length}
                  pageSize={pageSize}
                />
              </div>
            ) : null}
          </Form.Item>
        </div>

        <Drawer
          title="Edit Task"
          placement="right"
          width={'1200px'}
          closable
          onClose={onClose}
          extra={
            <Space>
              <Button type='primary' onClick={onClose}>Cancel</Button>
              <Button
                type='primary'
                onClick={() => {
                  onClose();
                  onFinish(workOrderJobPlanRef.current.getFieldsValue(), 'JobPlan', fileData);
                }}
              >
                Save
              </Button>
            </Space>
          }
          open={open}
        >
          <Form.List
            initialValue={formObject && formObject['TaskData'] ? formObject['TaskData'] : []}
            name="TaskData"
          >
            {(fields) => (
              <>
                {fields && Array.isArray(fields) && fields.length > 0
                  ? fields.map(({ key, name, ...restField }) => (
                    <div key={key} style={{ display: key === selectedTask ? 'block' : 'none' }}>
                      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <Form.Item
                          style={{ width: '100%', flex: '50%' }}
                          label={translation(translationCache, constant.name)}
                          {...restField}
                          name={[name, 'TaskName']}
                          rules={[{ required: true }]}
                        >
                          <InputComponent
                            placeholder={translation(translationCache, 'Name')}
                            style={{ width: '70%' }}
                          />
                        </Form.Item>

                        <Form.Item
                          style={{ width: '100%', flex: '50%' }}
                          label={translation(translationCache, constant.description)}
                          {...restField}
                          name={[name, 'TaskDescription']}
                          rules={[{ required: true }]}
                        >
                          <InputComponent
                            placeholder={translation(translationCache, 'Description')}
                            style={{ width: '70%' }}
                          />
                        </Form.Item>

                        <Form.Item
                          style={{ width: '100%', flex: '50%' }}
                          label={translation(translationCache, constant.startTime)}
                          {...restField}
                          name={[name, 'StartTime']}
                        >
                          <DatePicker
                            placeholder={translation(translationCache, constant.selectDate)}
                            inputReadOnly={true}
                            style={{ width: '70%' }}
                            format="YYYY-MM-DD HH:mm:ss"
                            onChange={(date, dateString) => {
                              datepickerChange(date, dateString, key, 'StartTime');
                            }}
                            showTime={{
                              defaultValue: moment('00:00:00', 'HH:mm:ss')
                            }}
                            disabledDate={(d) =>
                              !d ||
                              d.isAfter(
                                workOrderJobPlanRef.current.getFieldValue() &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData[
                                  key
                                  ] &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData[
                                  key
                                  ]['EndTime']
                                  ? moment(
                                    workOrderJobPlanRef.current.getFieldValue()
                                      .TaskData[key]['EndTime']
                                  )
                                    .add(1, 'day')
                                    .format('YYYY-MM-DD')
                                  : ''
                              ) ||
                              d.isBefore(
                                workOrderJobPlanRef.current.getFieldValue() &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData[
                                  key
                                  ] &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData[
                                  key
                                  ]['StartTime']
                                  ? moment(
                                    workOrderJobPlanRef.current.getFieldValue()
                                      .TaskData[key]['StartTime']
                                  ).format('YYYY-MM-DD')
                                  : ''
                              ) ||
                              d.isAfter(moment().add(1, 'day').format('YYYY-MM-DD'))
                            }
                            disabledTime={(e) =>
                              getDisabledHours(
                                moment(e, 'YYYY-MM-DD HH:mm:ss'),
                                key,
                                'StartTime'
                              )
                            }
                          />
                        </Form.Item>

                        <Form.Item
                          style={{ width: '100%', flex: '50%' }}
                          label={translation(translationCache, constant.endTime)}
                          {...restField}
                          name={[name, 'EndTime']}
                        >
                          <DatePicker
                            placeholder={translation(translationCache, constant.selectDate)}
                            inputReadOnly={true}
                            style={{ width: '70%' }}
                            format="YYYY-MM-DD HH:mm:ss"
                            onChange={(date, dateString) => {
                              datepickerChange(date, dateString, key, 'EndTime');
                            }} disabledDate={(d) =>
                              !d ||
                              d.isAfter(
                                this.workOrderJobPlanRef.current &&
                                  workOrderJobPlanRef.current !== null &&
                                  workOrderJobPlanRef.current.getFieldValue() &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData[
                                  key
                                  ] &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData[
                                  key
                                  ]['EndTime']
                                  ? moment(
                                    workOrderJobPlanRef.current.getFieldValue() &&
                                    workOrderJobPlanRef.current.getFieldValue()
                                      .TaskData &&
                                    workOrderJobPlanRef.current.getFieldValue()
                                      .TaskData[key] &&
                                    workOrderJobPlanRef.current.getFieldValue()
                                      .TaskData[key]['EndTime']
                                  )
                                    .add(1, 'day')
                                    .format('YYYY-MM-DD')
                                  : ''
                              ) ||
                              d.isBefore(
                                workOrderJobPlanRef.current &&
                                  workOrderJobPlanRef.current !== null &&
                                  workOrderJobPlanRef.current.getFieldValue() &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData[
                                  key
                                  ] &&
                                  workOrderJobPlanRef.current.getFieldValue().TaskData[
                                  key
                                  ]['StartTime']
                                  ? moment(
                                    workOrderJobPlanRef.current.getFieldValue() &&
                                    workOrderJobPlanRef.current.getFieldValue()
                                      .TaskData &&
                                    workOrderJobPlanRef.current.getFieldValue()
                                      .TaskData[key] &&
                                    workOrderJobPlanRef.current.getFieldValue()
                                      .TaskData[key]['StartTime']
                                  ).format('YYYY-MM-DD')
                                  : ''
                              ) ||
                              d.isAfter(moment().add(1, 'day').format('YYYY-MM-DD'))
                            }
                            disabledTime={(e) =>
                              getDisabledHours(
                                moment(e, 'YYYY-MM-DD HH:mm:ss'),
                                key,
                                'EndTime'
                              )
                            }
                            showTime={{
                              defaultValue: moment('00:00:00', 'HH:mm:ss')
                            }}
                          />{' '}
                        </Form.Item>
                        {workOrderStatus && workOrderStatus === 'CLOSE' ? (
                          <>
                            <Form.Item
                              style={{ width: '100%', flex: '50%' }}
                              label={translation(translationCache, constant.actualStartTime)}
                              {...restField}
                              name={[name, 'ActualStartTime']}
                            >
                              <DatePicker
                                placeholder={translation(
                                  translationCache,
                                  constant.selectDate
                                )}
                                inputReadOnly={true}
                                style={{ width: '70%' }}
                                format="YYYY-MM-DD HH:mm:ss"
                                showTime={{
                                  defaultValue: moment('00:00:00', 'HH:mm:ss')
                                }}
                                disabledDate={disabledDate}
                                disabledHours={() => getDisabledHours(moment(), key, 'ActualStartTime')}
                                disabledMinutes={disabledMinutes}
                              />{' '}
                            </Form.Item>
                            <Form.Item
                              style={{ width: '100%', flex: '50%' }}
                              label={translation(translationCache, constant.actualEndTime)}
                              {...restField}
                              name={[name, 'ActualEndTime']}
                            >
                              <DatePicker
                                placeholder={translation(
                                  translationCache,
                                  constant.selectDate
                                )}
                                inputReadOnly={true}
                                style={{ width: '70%' }}
                                format="YYYY-MM-DD HH:mm:ss"
                                showTime={{
                                  defaultValue: moment('00:00:00', 'HH:mm:ss')
                                }}
                                disabledDate={disabledDate}
                                disabledHours={() => disabledEndHours} /> {' '}
                            </Form.Item>
                          </>
                        ) : null}
                        <Form.Item
                          style={{ width: '100%', flex: '50%' }}
                          label={translation(translationCache, constant.estimatedDuration)}
                          {...restField}
                          name={[name, 'EstimatedDuration']}
                        >
                          <InputComponent
                            style={{ width: '70%' }}
                            placeholder={translation(translationCache, 'EstimatedDuration')}
                          />
                        </Form.Item>

                        <Form.Item
                          style={{ width: '100%', flex: '50%' }}
                          label={translation(translationCache, constant.UOM)}
                          name={[name, 'UOM']}
                        >
                          <Select
                            style={{ width: '70%' }}
                            placeholder={translation(translationCache, 'Select UOM')}
                          >
                            {UOMList && Array.isArray(UOMList) && UOMList.map((uom, index) => (
                              <Select.Option key={index} value={uom.UOM}>
                                {uom.UOM}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>

                        <Form.Item style={{ width: '100%', flex: '50%' }} name={[name, 'Observation']}></Form.Item>
                        <Form.Item style={{ width: '100%', flex: '50%' }} name={[name, 'PlannedSequence']}></Form.Item>
                        <Form.Item style={{ width: '100%', flex: '50%' }} name={[name, 'Criteria']}></Form.Item>
                        <Form.Item style={{ width: '100%', flex: '50%' }} name={[name, 'RecordBy']}></Form.Item>
                        <Form.Item style={{ width: '100%', flex: '50%' }} name={[name, 'CheckedBy']}></Form.Item>
                        <Form.Item style={{ width: '100%', flex: '50%' }}></Form.Item>
                        <Form.Item style={{ width: '100%', flex: '50%' }}>
                          <InputComponent style={{ display: 'none' }} />
                        </Form.Item>
                      </div>
                    </div>
                  )) : null}
              </>
            )}
          </Form.List>
        </Drawer>
      </Form>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(WorkOrderJobPlanesTask);